export default function CForLoop() {
  return <h2>C For Loop</h2>;
}
